import { render } from "./LoaderContainer.vue?vue&type=template&id=07df47e2&scoped=true"
const script = {}

import "./LoaderContainer.vue?vue&type=style&index=0&id=07df47e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07df47e2"]])

export default __exports__